"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CrossCircleIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-77 -560)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(77 560)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(6 6)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M10.752.248a.846.846 0 01.07 1.117l-.07.08L6.697 5.5l4.055 4.056a.846.846 0 01-1.117 1.267l-.08-.07L5.5 6.696l-4.056 4.055A.846.846 0 01.177 9.635l.07-.08L4.304 5.5.248 1.444A.846.846 0 011.365.177l.08.07L5.5 4.304 9.556.248a.846.846 0 011.196 0z",
            fill: color,
            fillRule: "nonzero"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M11.5 23C17.851 23 23 17.851 23 11.5S17.851 0 11.5 0 0 5.149 0 11.5 5.149 23 11.5 23zm0-2a9.5 9.5 0 110-19 9.5 9.5 0 010 19z",
          fill: color,
          fillRule: "nonzero"
        })]
      })
    })
  })]
});

CrossCircleIcon.defaultProps = {
  color: "currentColor",
  title: undefined
};
var _default = CrossCircleIcon;
exports.default = _default;